/**
 * 登录部分的api地址
 */

export default{
	GetExperienceToken:'/apiuser/ZdapSSO/GetExperienceToken',//体验token
	// GetExperienceToken:'/yssxs/OAuth/GetExperienceToken',//体验token
	SaveIntentionUser:'/zsb/IntentionUser/SaveIntentionUser',
	GetToken:'/apiuser/ZdapSSO/GetToken',// 通过用户id 获取token
}


// WEBPACK FOOTER //
// ./src/api/urls/login.js